import { createSelector } from 'reselect'
import { AppState } from 'Store'

const selectEntries = (state: AppState) => state.advertisement.organization.org_list.entries
const selectOrgList = (state: AppState) => state.advertisement.organization.org_list
const selectCurrentParams = (state: AppState) => state.advertisement.organization.requestParams
const selectTotal = (state: AppState) => state.advertisement.organization.org_list.total_entries
const selectOrg = (state: AppState) => state.advertisement.organization.org
const selectDict = (state: AppState) => state.advertisement.organization.dict
const selectOpenedOrg = (state: AppState) => state.advertisement.organization.openedOrg
const selectOrganizationKinds = createSelector(selectDict, (dict) => dict.organizations?.kinds)
const selectPlatformsKinds = createSelector(selectDict, (dict) => dict.platforms?.kinds)
const selectActiveTab = (state: AppState) => state.advertisement.organization.activeTab
const selectKktu = createSelector(selectDict, (dict) => dict?.kktu_values)

const getOrgId = createSelector(selectOrgList, (org) => {
	return {
		...org,
		entries: org.entries.map((org) => ({
			...org,
			id: org.id,
			name: `${org.inn} (${org.name})`,
		})),
	}
})
export const organizationSelector = {
	selectEntries,
	selectOrgList,
	selectCurrentParams,
	selectTotal,
	selectOrg,
	selectDict,
	selectOpenedOrg,
	selectOrganizationKinds,
	selectPlatformsKinds,
	getOrgId,
	selectActiveTab,
	selectKktu,
}
